import React from 'react';
import { useFocusTrap } from '../../hooks/useFocusTrap';
import { useEscapeKey } from '../../hooks/useEscapeKey';
import './ScopeSelectionDialog.css';

/**
 * 繰り返し予約の編集・削除範囲選択ダイアログ
 */
const ScopeSelectionDialog = ({ isOpen, onClose, onSelect, actionType = 'edit' }) => {
  // アクセシビリティ: フォーカストラップとEscキー対応
  const modalRef = useFocusTrap(isOpen);
  useEscapeKey(onClose, isOpen);

  if (!isOpen) return null;

  const title = actionType === 'delete' ? '予約の削除' : '予約の編集';
  const message = actionType === 'delete'
    ? 'この予約は繰り返し予約です。どの範囲を削除しますか？'
    : 'この予約は繰り返し予約です。どの範囲を編集しますか？';

  const handleSelect = (scope) => {
    onSelect(scope);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="scope-dialog"
        onClick={(e) => e.stopPropagation()}
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="scope-dialog-title"
      >
        <div className="scope-dialog-header">
          <h3 id="scope-dialog-title">{title}</h3>
          <button className="modal-close" onClick={onClose} aria-label="閉じる">
            ✕
          </button>
        </div>

        <div className="scope-dialog-body">
          <p style={{ marginBottom: '20px', color: '#5f6368', fontSize: '14px' }}>
            {message}
          </p>

          <div className="scope-options">
            <button
              className="scope-option"
              onClick={() => handleSelect('this')}
            >
              <div className="scope-option-title">この予約のみ</div>
              <div className="scope-option-description">
                選択した予約のみを{actionType === 'delete' ? '削除' : '編集'}します
              </div>
            </button>

            <button
              className="scope-option"
              onClick={() => handleSelect('future')}
            >
              <div className="scope-option-title">この予約と今後の予約</div>
              <div className="scope-option-description">
                選択した予約と、それ以降の予約を{actionType === 'delete' ? '削除' : '編集'}します
              </div>
            </button>

            <button
              className="scope-option"
              onClick={() => handleSelect('all')}
            >
              <div className="scope-option-title">すべての予約</div>
              <div className="scope-option-description">
                繰り返し予約シリーズ全体を{actionType === 'delete' ? '削除' : '編集'}します
              </div>
            </button>
          </div>
        </div>

        <div className="scope-dialog-footer">
          <button className="btn-secondary" onClick={onClose}>
            キャンセル
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScopeSelectionDialog;
